import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class ColorBarViewModel extends ControlViewModel {
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * Der aktuelle Wert
     */
    public current: number;

    /**
     * Der Maximalwert
     */
    public complete: number;

    /**
     * Die angezeigte Farbe
     */
    public color: string;

    /**
     * Die breite der ColorBar in Prozent
     */
    public width: KnockoutComputed<number>;

    /**
     * Der angezeigte Wert
     */
    public label: LabelViewModel;

    /**
     * Das ViewModel für die ColorBar
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);
        this.current = this.paramOrDefault(params.current, 0, this.parseMyFloat);
        this.complete = this.paramOrDefault(params.complete, 100, this.parseMyFloat);
        this.color = this.paramOrDefault(params.color, '#ffffff');
        this.width = this.definePureComputed(() => {
            return (this.current / this.complete) * 100;
        });
        this.label = new this.LabelViewModel({
            parentLocator: this.locator,
            locator: 'label',
            caption: kendo.toString(this.current, "n") + ""
        });
    }

    private parseMyFloat(f: string | number): number {
        if (typeof f == 'string') {
            f = f.replace(/,/g, '.');

            return parseFloat(f);
        }
        return f;
    }
}

ComponentManager.setViewModel('ColorBarViewModel', ColorBarViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');